module.exports = __webpack_public_path__ + "warning.svg";